module.exports = __webpack_public_path__ + "static/shuttleid-partnership-sm-8092346fa995d24492454773c1ecc600.jpg";